import React from "react";
import { COMPANY } from "../data/site";

/**
 * Brand lockup.
 *  - 'inline-light' (cream bg, e.g. navbar): renders the full paddle + wordmark
 *    PNG (paddle on top + 'GATEWAY BOAT CO.' / 'BOZEMAN, MT' below).
 *  - 'inline-dark'  (navy bg, e.g. footer): renders the wooden paddle PNG on the
 *    left + cream-colored wordmark text on the right, since the full PNG's navy
 *    wordmark would be invisible on a navy background.
 */
export default function Logo({ variant = "inline-light", size = "md", testId = "site-logo" }) {
  if (variant === "inline-dark") {
    const sizes = {
      sm: { paddle: "w-24 md:w-28", title: "text-sm md:text-base tracking-[0.18em]", sub: "text-[0.55rem] md:text-[0.6rem] tracking-[0.28em]" },
      md: { paddle: "w-32 md:w-40", title: "text-base md:text-xl tracking-[0.18em]", sub: "text-[0.6rem] md:text-[0.65rem] tracking-[0.28em]" },
      lg: { paddle: "w-40 md:w-52", title: "text-xl md:text-2xl tracking-[0.18em]", sub: "text-[0.65rem] md:text-[0.75rem] tracking-[0.28em]" },
    };
    const s = sizes[size] || sizes.md;
    return (
      <div className="flex items-center gap-4" data-testid={testId}>
        <img
          src={COMPANY.paddle}
          alt=""
          className={`${s.paddle} h-auto select-none`}
          draggable={false}
        />
        <div className="flex flex-col leading-none">
          <span className={`font-serif ${s.title} text-[#f7f4ec] uppercase font-medium`}>
            Gateway Boat Co.
          </span>
          <span className={`font-sans ${s.sub} text-[#b8895a] uppercase mt-1 md:mt-1.5 font-medium`}>
            Bozeman, MT
          </span>
        </div>
      </div>
    );
  }

  // inline-light — use the full lockup PNG (paddle + navy wordmark baked in)
  // Full logo aspect is ~3.17:1 (wider than tall)
  const heights = {
    sm: "h-10 md:h-12",
    md: "h-16 md:h-20",
    lg: "h-20 md:h-24",
  };
  return (
    <img
      src={COMPANY.logoFull}
      alt="Gateway Boat Co., Bozeman, MT"
      className={`${heights[size] || heights.md} w-auto select-none`}
      draggable={false}
      data-testid={testId}
    />
  );
}
